module.exports = "pegasus/assets/hexagon-google.gif";